module.exports = __webpack_public_path__ + "static/media/defaultCard.5419fbb3.svg";